import React from 'react';
import Button from '../common/Button';
import './loginStyle.css';

const InactivityModal = ({ onAccept, eviewMode = false }) => {
  const modalClass = `login-modal ${eviewMode ? 'eview-mode' : ''}`;

  return (
    <div className={modalClass}>
      <p className="login-modal__title">Inactivity Timeout</p>
      <p className="login-modal__text">
        You have reached the inactivity timeout set for your user.
      </p>
      <p className="login-modal__text login-modal__text--emphasis">
        Your session has been terminated.
      </p>
      <div className="login-modal__buttons">
        <Button onClick={onAccept} buttonText="OK" />
      </div>
    </div>
  );
};

export default InactivityModal;